const initialState =
{
	id                          : null,
	picture                     : null,
	browser                     : null,
	roles                       : [],
	canSendMic                  : false,
	canSendWebcam               : false,
	canShareScreen              : false,
	canShareFiles               : false,
	audioDevices                : null,
	webcamDevices               : null,
	webcamInProgress            : false,
	audioInProgress             : false,
	screenShareInProgress       : false,
	displayNameInProgress       : false,
	loginEnabled                : false,
	raisedHand                  : false,
	raisedHandInProgress        : false,
	loggedIn                    : false,
	isSpeaking                  : false,
	isAutoMuted                 : true,
	displayName                 : '',
	lan                         : 'en',
	isBreakoutRoom              : false,
	roleType                    : null,
	email                       : '',
	name                        : '',
	cloudRecordingInProgress    : false,
	streamingInProgress         : false,
	youtubeStreamingInProgress  : false,
	faceBookStreamingInProgress : false,
	accessAnnotations           : false,
	pause                       : false,
	screenShareStatus           : false,
	screenSharePeerId           : null,
	socketId                    : null
};

const me = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_ME':
		{
			const {
				peerId,
				loginEnabled,
				email, name,
				socketId
			} = action.payload;

			return {
				...state,
				id           : peerId ? peerId : state.id,
				loginEnabled : loginEnabled ? loginEnabled : state.loginEnabled,
				email        : email ? email : state.email,
				name         : name ? name : state.name,
				socketId     : socketId ? socketId : state.socketId
			};

		}

		case 'SET_BROWSER':
		{
			const { browser } = action.payload;

			return { ...state, browser };
		}
		case 'SET_DISPLAY_NAME':
		{
			const { displayName } = action.payload;

			return { ...state, displayName };
		}
		case 'SET_LANGUAGE':
		{
			const { lan } = action.payload;

			return { ...state, lan };
		}
		case 'LOGGED_IN':
		{
			const { flag } = action.payload;

			return { ...state, loggedIn: flag };
		}

		case 'ADD_ROLE':
		{
			const roles = [ ...state.roles, action.payload.roleId ];

			return { ...state, roles };
		}

		case 'SET_ROLES':
		{
			const roles = [ ...action.payload.roles ];

			return { ...state, roles };
		}

		case 'REMOVE_ROLE':
		{
			const roles = state.roles.filter((roleId) =>
				roleId !== action.payload.roleId);

			return { ...state, roles };
		}
		case 'CLEAR_ROLES':
		{
			const roles = [];

			return { ...state, roles };

		}

		case 'SET_PICTURE':
		{
			return { ...state, picture: action.payload.picture };
		}

		case 'SET_ANNOTATIONS':
		{

			const { annotationAccess } = action.payload;

			return { ...state, accessAnnotations: annotationAccess };
		}

		case 'SET_PAUSE':
		{
			const { pause } = action.payload;

			return { ...state, pause: pause };
		}

		case 'SET_MEDIA_CAPABILITIES':
		{
			const {
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			} = action.payload;

			return {
				...state,
				canSendMic,
				canSendWebcam,
				canShareScreen,
				canShareFiles
			};
		}

		case 'SET_AUDIO_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioDevices: devices };
		}

		case 'SET_AUDIO_OUTPUT_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, audioOutputDevices: devices };
		}

		case 'SET_WEBCAM_DEVICES':
		{
			const { devices } = action.payload;

			return { ...state, webcamDevices: devices };
		}

		case 'SET_AUDIO_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, audioInProgress: flag };
		}

		case 'SET_WEBCAM_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, webcamInProgress: flag };
		}

		case 'SET_SCREEN_SHARE_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, screenShareInProgress: flag };
		}

		case 'SET_RAISED_HAND':
		{
			const { flag } = action.payload;

			return { ...state, raisedHand: flag };
		}

		case 'SET_RAISED_HAND_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, raisedHandInProgress: flag };
		}

		case 'SET_DISPLAY_NAME_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, displayNameInProgress: flag };
		}

		case 'SET_IS_SPEAKING':
		{
			const { flag } = action.payload;

			return { ...state, isSpeaking: flag };
		}

		case 'SET_AUTO_MUTED':
		{
			const { flag } = action.payload;

			return { ...state, isAutoMuted: flag };
		}

		case 'SET_IS_BREAKOUTROOM':
		{
			const { isBreakoutRoom } = action.payload;

			return { ...state, isBreakoutRoom: isBreakoutRoom };
		}

		case 'SET_ROLE_TYPE':
		{
			const { roleType } = action.payload;

			return { ...state, roleType };
		}

		case 'SET_IS_CLOUDRECORDING_IN_PROGRESS':
		{
			const { flag } = action.payload;

			return { ...state, cloudRecordingInProgress: flag };
		}

		case 'SET_IS_STREAMING_IN_PROGRESS':
		{
			const { isStreamingStart } = action.payload;

			return { ...state, streamingInProgress: isStreamingStart };
		}

		case 'SET_IS_YOUTUBE_IN_PROGRESS':
		{
			const { youtubeStreamingInProgress } = action.payload;

			return { ...state, youtubeStreamingInProgress };

		}

		case 'SET_IS_FACEBOOK_IN_PROGRESS':
		{
			const { faceBookStreamingInProgress } = action.payload;

			return { ...state, faceBookStreamingInProgress };

		}
		case 'SET_SCREEN_SHARE_STATUS':
		{
			const { screenShareStatus } = action.payload;

			return { ...state, screenShareStatus };
		}
		case 'SET_SCREEN_SHARE_PEER_ID':
		{
			const { screenSharePeerId } = action.payload;

			return { ...state, screenSharePeerId };
		}

		default:
			return state;
	}
};

export default me;
